var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 4.66699H24.5V16.0003H7.49996V4.66699Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6666 20.2503H10.3333V27.3337H21.6666V20.2503ZM11.75 21.667H14.5833V25.917H11.75V21.667Z",
    fill: "#414042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416626 3.25033C0.416626 1.68563 1.68518 0.416992 3.24996 0.416992H28.75C30.3147 0.416992 31.5833 1.68563 31.5833 3.25033V28.7503C31.5833 30.315 30.3147 31.5837 28.75 31.5837H3.24996C1.68518 31.5837 0.416626 30.315 0.416626 28.7503V3.25033ZM3.24996 4.66699C3.24996 3.88464 3.88419 3.25033 4.66663 3.25033H27.3333C28.1157 3.25033 28.75 3.88464 28.75 4.66699V27.3337C28.75 28.116 28.1157 28.7503 27.3333 28.7503H4.66663C3.88419 28.7503 3.24996 28.116 3.24996 27.3337V4.66699Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveSetup);
export default __webpack_public_path__ + "static/media/SaveSetup.910371d015b348a62468a71413f843c4.svg";
export { ForwardRef as ReactComponent };